import { Capacitor } from '@capacitor/core';
import { devPurchaseWorld, unavailablePurchasesAdapter } from './fakePurchases';
import type { PurchasesAdapter } from './purchasesContract';
import { revenueCatAdapter } from './revenueCatAdapter';
import { createWebPurchasesAdapter, webPurchaseLink, webPurchasesAdapter } from './webPurchasesAdapter';
import { devWebVersionWanted } from '../app/webVersion';

// Single selection point for the purchase lane, exactly like src/native/mediaAdapter.ts:
//   native app      → the real App Store / Google Play lane through RevenueCat
//   web build       → RevenueCat Web Billing (item 39) when the build carries the web purchase link
//   dev server      → the simulated store (DEVELOPMENT ONLY; import.meta.env.DEV is false in a build);
//                     with the web-version switch (src/app/webVersion.ts) the web lane instead, with a
//                     payment page that simply comes straight back
//   anything else   → "purchases are not available here", said plainly, never faked
// Tests inject their own adapter through setPurchasesAdapterForTests.
let override: PurchasesAdapter | null = null;
let devWeb: PurchasesAdapter | null = null;

export function getPurchasesAdapter(): PurchasesAdapter {
  if (override) return override;
  if (Capacitor.isNativePlatform()) return revenueCatAdapter;
  if (webPurchaseLink().length > 0 && !import.meta.env.DEV) return webPurchasesAdapter;
  if (import.meta.env.DEV) {
    if (devWebVersionWanted()) {
      devWeb ??= createWebPurchasesAdapter({
        link: () => 'https://pay.rev.cat/dev-preview-link',
        navigate: (url) => {
          (window as unknown as { __lastWebCheckoutUrl?: string }).__lastWebCheckoutUrl = url;
          window.location.assign(`${window.location.pathname}?purchase=done&dev=1`);
        }
      });
      return devWeb;
    }
    return devPurchaseWorld().adapter;
  }
  return unavailablePurchasesAdapter;
}

export function setPurchasesAdapterForTests(adapter: PurchasesAdapter | null): void {
  override = adapter;
}
